import { ca } from '@cian/analytics';

export const trackTourCards = (label: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'card',
    action: 'Click',
    label,
    useLastProducts: true,
  });
};
